import React from 'react';

import { Progress, Bar } from './ProgressBar.styles';

export class ProgressBarComponent extends React.Component {
  state = {
    elapsedTime: 0, // in ms
  };
  start = new Date();
  componentDidMount() {
    this.timer = setInterval(() => {
      const elapsedTime = new Date() - this.start;
      this.setState({
        elapsedTime,
      });
    }, 30); // ~30 frames per second
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const percentageElapsed = (this.state.elapsedTime / (this.props.expiration - this.start)) * 100;
    const progress = percentageElapsed > 100 ? 100 : percentageElapsed;

    return (
      <Bar>
        <Progress progress={progress} />
      </Bar>
    );
  }
}

export default ProgressBarComponent;
